import type Variant from '@modules/product/type/variant';
import { isEcomPriceType } from '../util/is-ecom-price-type';
import type { ProductPricingTypeEnum } from 'generated/graphql';

export const variantHasPrice = (
    variant: Pick<Variant, 'Price' | 'MaxPrice'>,
    pricingType: ProductPricingTypeEnum,
): boolean => {
    return (
        (variant?.Price.Amount ?? 0) > 0 ||
        (!isEcomPriceType(pricingType) && (variant?.MaxPrice.Amount ?? 0) > 0)
    );
};
